import React from "react";
import { Row, Col } from "antd";
import { FaExternalLinkSquareAlt } from "react-icons/fa";
import { map } from "underscore";
import { IDeepDiveModalConfig } from "@ts/common-types";

interface IProductOverviewCards {
    widgetData: IDeepDiveModalConfig;
}

const ProductOverviewCards: React.FC<IProductOverviewCards> = ({ widgetData }) => {
    return widgetData.overview?.brandScoreInfo ? (
        <Row>
            {map(Object.entries(widgetData.overview?.brandScoreInfo),
                ([key, value]) => (
                    <Col span={6} className="p-1 d-flex" key={key}>
                        <div
                            className="product-overview-cards p-3 text-left rounded-4 mb-2"
                            style={{ backgroundColor: "white", width: "95%",}}
                        >
                            <div className="mb-2">{value.name || key}</div>
                            <div className="d-flex align-items-center justify-content-start">
                                <h4>{value.value}</h4>
                                {value.link && (
                                    <FaExternalLinkSquareAlt
                                        style={{
                                            position: "relative",
                                            top: "-8px",
                                            left: "10%",
                                        }}
                                        className="d-none text-primary"
                                        role="button"
                                    />
                                )}
                                {value.percChange ? (
                                    <p
                                        className={`text-${
                                            value.percChange.split("")[0] ===
                                            "-"
                                                ? "danger"
                                                : "success"
                                        } ms-2 my-1`}
                                    >
                                        {value.percChange}
                                    </p>
                                ) : null}
                            </div>

                        </div>
                    </Col>
                )
            )}
        </Row>
    ) : null;
};

export default ProductOverviewCards;
